/**
 * @generated SignedSource<<05a092da2349664283ea311c5ad087c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftCreatorsLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftCreatorTiles_viewer" | "NftFeaturedCreators_viewer">;
  readonly " $fragmentType": "NftCreatorsLayout_viewer";
};
export type NftCreatorsLayout_viewer$key = {
  readonly " $data"?: NftCreatorsLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftCreatorsLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "creatorsItemCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftCreatorsLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftFeaturedCreators_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "creatorsItemCount",
          "variableName": "creatorsItemCount"
        }
      ],
      "kind": "FragmentSpread",
      "name": "NftCreatorTiles_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3fabc435f199f893e6a70e4593635985";

export default node;
